import Marquee from "react-fast-marquee";

const ITEMS = [
  "VPT ENGINEERING",
  "LKW OPTIMIERUNG",
  "AGRAR TUNING",
  "ECO TUNING",
  "VMAX OFF",
  "DPF LÖSUNGEN",
  "GETRIEBE TUNING",
  "ECU FILESERVICE",
];

export default function MarqueeBar() {
  return (
    <div className="bg-primary text-primary-foreground border-y border-black/10 py-4 select-none">
      <Marquee autoFill speed={55} gradient={false}>
        {ITEMS.map((t, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-display font-bold uppercase tracking-wider text-lg md:text-xl">
              {t}
            </span>
            <span className="text-2xl leading-none">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
